import React, { useEffect, useState, memo } from 'react';
import styled from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import InformationList from '../InformationList/InformationList';
import InformationListItem from '../InformationList/InformationListItem';
import { formatMoneyNumeral } from '../../util/helpers/numeralHelpers';
import themeColors from '../../assets/styles/themeColors';
import { pxToRem } from '../../assets/styles/helper';

const PriceListContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 100%;
  border-bottom: 1px solid ${themeColors.colorBorderPrimary}66;
  border-top: 1px solid ${themeColors.colorBorderPrimary}66;
`;

const ScrollableList = styled.div`
  // flex: 1;
  min-height: 0;
  overflow-y: auto;
  padding-right: ${pxToRem(4)};
`;

const StickyTotal = styled.div`
  flex-shrink: 0;
  background: ${themeColors.colorBackgroundPrimary};
`;

const OrderReviewPriceList = ({
  paymentMethodInfo,
  paymentDiscount,
  selectedPaymentMethod,
  calculation,
  onClick,
  paymentDiscountValue2,
}) => {
  const { t } = useTranslation();
  const [orderInformationListData, setOrderInformationListData] = useState([]);

  // useEffect(() => {
  //   setOrderInformationListData(dataForOrder);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [paymentMethodInfo, paymentDiscount]);

  // useEffect(() => {
  //   setOrderDiscountedTotal(dataForDiscountedTotal);
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [paymentMethodInfo, paymentDiscount]);

  useEffect(() => {
    setOrderInformationListData({
      pricePerUnit: paymentMethodInfo?.ClientPricePerUnit,
      estimatedTotal: paymentMethodInfo?.TotalClientExecutionPrice,
      volumeDiscount: paymentMethodInfo?.VolumeDiscount ?? 0,
      paymentTypeDiscount: paymentDiscount ?? paymentDiscountValue2,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedPaymentMethod, paymentMethodInfo]);

  const dataForOrder = [
    {
      label: t('buyWizard.pricePerUnit'),
      value: formatMoneyNumeral(orderInformationListData?.pricePerUnit),
    },
    selectedPaymentMethod?.PaymentMethodType !== 3
      ? {
          label: t('buyWizard.cashDiscount'),
          value: `-${formatMoneyNumeral(
            orderInformationListData?.paymentTypeDiscount,
          )}`,
          isValueBold: true,
          isColored: themeColors.colorSuccess,
        }
      : {
          lable: '',
          value: '',
        },
    {
      label: t('buyWizard.volumeDiscount'),
      value: formatMoneyNumeral(orderInformationListData?.volumeDiscount),
      infoIcon: true,
      onClick,
    },
    calculation?.deliveryFee !== null
      ? {
          label: t('buyWizard.deliveryCost'),
          value: formatMoneyNumeral(calculation?.deliveryFee),
        }
      : {},
    calculation?.salesTax !== null
      ? {
          label: t('buyWizard.salesTax'),
          value: formatMoneyNumeral(calculation?.salesTax),
        }
      : {},
  ];

  const dataForDiscountedTotal = [
    {
      label: t('buyWizard.discountedTotal'),
      value: formatMoneyNumeral(orderInformationListData?.estimatedTotal),
      isValueBold: true,
    },
  ];

  return (
    <PriceListContainer>
      <ScrollableList>
        <InformationList marginTop={8}>
          {dataForOrder.map(
            ({
              label,
              value,
              isColored,
              isBold,
              isValueBold,
              infoIcon,
              onClick,
            }) => (
              <InformationListItem
                key={uuidv4()}
                label={label}
                value={value}
                isColored={isColored}
                isBold={isBold}
                isValueBold={isValueBold}
                fullWidth
                infoIcon={infoIcon}
                onClick={onClick}
              />
            ),
          )}
        </InformationList>
      </ScrollableList>

      <StickyTotal>
        <InformationList marginTop={10}>
          {dataForDiscountedTotal.map(
            ({ label, value, isColored, isBold, isValueBold }) => (
              <InformationListItem
                key={uuidv4()}
                label={label}
                value={value}
                isColored={isColored}
                isBold={isBold}
                isValueBold={isValueBold}
                fullWidth
              />
            ),
          )}
        </InformationList>
      </StickyTotal>
    </PriceListContainer>
  );
};

OrderReviewPriceList.propTypes = {
  paymentMethodInfo: PropTypes.shape({
    ClientPricePerUnit: PropTypes.number,
    TotalClientExecutionPrice: PropTypes.number,
    VolumeDiscount: PropTypes.number,
  }),
  paymentDiscount: PropTypes.number,
  selectedPaymentMethod: PropTypes.shape({
    PaymentMethodType: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
  }),
  calculation: PropTypes.shape({
    salesTax: PropTypes.number,
    deliveryFee: PropTypes.number,
    volumeDiscount: PropTypes.number,
    paymentTypeDiscount: PropTypes.number,
  }),
  onClick: PropTypes.func,
  paymentDiscountValue2: PropTypes.number,
};

export default memo(OrderReviewPriceList);
